import gql from 'graphql-tag'
import ProjectsPage from './projectsPage'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { RigipsStore } from 'redux/redux'
import { withTranslation } from 'react-i18next'

export const ProjectsQuery = gql`
  query getProjects {
    getProjects {
      id: projectNumber
      projectNumber
      projectName
      projectSumBrutto
    }
  }
`

export const DeleteProjects = gql`
  mutation DeleteProjects($projectNumber: [String!]!) {
    deleteProjects(projectNumber: $projectNumber)
  }
`

export const DuplicateProject = gql`
  mutation DuplicateProject($version: String!, $projectNumber: String!) {
    duplicateProject(version: $version, projectNumber: $projectNumber)
  }
`

const mapStateToProps = (state: RigipsStore) => {
  const { auth } = state
  const { authenticated } = auth

  return { authenticated }
}

const withConnect = connect(mapStateToProps)

export default withConnect(withRouter(withTranslation()(ProjectsPage)))
